import { render } from "./BaseButton.vue?vue&type=template&id=881c6f48&scoped=true"
const script = {}

import "./BaseButton.vue?vue&type=style&index=0&id=881c6f48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-881c6f48"]])

export default __exports__